export default "__VITE_ASSET__DiJkWKQC__"